"use client"

import { Col, Row } from "antd"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { FlightSearchPrefill } from "./flightSearchPrefill"
import FormSearchFlightSkeleton from "../SearchFlightsDesktop/FormSearchFlight.skeleton"
import DrawerFormSearchFlightSkeleton from "../../FormSearch/mobile/DrawerFormSearchFlight.skeleton"

const FlightSearchBoxSkeleton = ({ prefill }: { prefill?: FlightSearchPrefill }) => {
  const isDesktop = useIsDesktop()
  
  if (!isDesktop) {
    return <DrawerFormSearchFlightSkeleton autoHeight prefill={prefill} />
  }

  return (
    <Row
      justify='center'
      style={{
        paddingBlock: '6rem',
        marginBottom: '4rem',
        backgroundImage: `url("/static/images/bg-ve-may-bay.png")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'
      }}
    >
      <Col span={24} className="flight__search-box--container">
        <Title style={{ margin: 0, marginBottom: '0.5rem', color: '#ffffff' }} level={3}>
          Vé máy bay
        </Title>
      </Col>
      <Col span={24}>
        <FormSearchFlightSkeleton fixedPosition={false} prefill={prefill} />
      </Col>
    </Row>
  )
}

export default FlightSearchBoxSkeleton